import { ReducersMapObject } from '@reduxjs/toolkit';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import administration from 'app/modules/administration/administration.reducer';
import userManagement from 'app/modules/administration/user-management/user-management.reducer';
import activate from 'app/modules/account/activate/activate.reducer';
import password from 'app/modules/account/password/password.reducer';
import settings from 'app/modules/account/settings/settings.reducer';
import passwordReset from 'app/modules/account/password-reset/password-reset.reducer';
import entitiesReducers from 'app/entities/reducers';
import applicationProfile from './application-profile';
import authentication from './authentication';
import locale from './locale';
import caseFormChange from 'app/shared/reducers/case-form-change';
import niasNavbar from 'app/shared/reducers/niasnavbar';
import screenSize from 'app/shared/reducers/screen-size';
import caseEntity from 'app/shared/reducers/case-entity';
import keycloak from 'app/shared/reducers/keycloak';
import validationErrors from 'app/shared/reducers/validationerrors/validation-errors.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const rootReducer: ReducersMapObject = {
  authentication,
  locale,
  applicationProfile,
  administration,
  userManagement,
  activate,
  passwordReset,
  password,
  settings,
  screenSize,
  caseEntity,
  caseFormChange,
  niasNavbar,
  loadingBar,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  ...entitiesReducers,
  keycloak,
  validationErrors,
};

export default rootReducer;
